module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/db-1200@2x-28a14fa22d3f2f21a50cfbea7f8c54c4.webp";